import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "dataForm",
  style: {"min-width":"800px"}
}
const _hoisted_2 = { class: "underlineForm" }
const _hoisted_3 = { class: "mb-20 fullWidth" }
const _hoisted_4 = { class: "fullWidth" }
const _hoisted_5 = { class: "dialog-footer mt-20" }
const _hoisted_6 = { class: "dialog-footer" }
const _hoisted_7 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_BusinessTable = _resolveComponent("BusinessTable")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_PrintCom = _resolveComponent("PrintCom")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: "dataForm",
      model: _ctx.ruleForm,
      rules: _ctx.rules,
      "label-position": "top",
      "label-width": "100px",
      class: "mb-20"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_form_item, {
            label: "所属公司",
            prop: "titleId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                class: "filter-item",
                filterable: true,
                modelValue: _ctx.ruleForm.titleId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ruleForm.titleId) = $event)),
                placeholder: "输入关键字搜索",
                clearable: "",
                remote: "",
                "remote-method": _ctx.getTitleOptionRemote,
                onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getTitleOptionRemote(''))),
                onChange: _ctx.handleCompanyTitleChange
              }, {
                default: _withCtx(() => [
                  (_ctx.titleOption.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.titleOption, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.name,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    : (_openBlock(), _createBlock(_component_el_option, {
                        key: 1,
                        value: -1,
                        disabled: ""
                      }, {
                        default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                          _createTextVNode("暂无数据", -1)
                        ]))]),
                        _: 1
                      }))
                ]),
                _: 1
              }, 8, ["modelValue", "remote-method", "onChange"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "税率",
            prop: "taxRate"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                class: "filter-item",
                filterable: true,
                modelValue: _ctx.ruleForm.taxRate,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ruleForm.taxRate) = $event)),
                placeholder: "输入关键字搜索",
                clearable: "",
                onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleCalcTotal(1)))
              }, {
                default: _withCtx(() => [
                  (_ctx.taxRateList.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.taxRateList, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item,
                          label: item + '%',
                          value: item
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    : (_openBlock(), _createBlock(_component_el_option, {
                        key: 1,
                        value: -1,
                        disabled: ""
                      }, {
                        default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                          _createTextVNode("暂无数据", -1)
                        ]))]),
                        _: 1
                      }))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "客户公司名称",
            prop: "customerCompanyId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                class: "filter-item",
                filterable: true,
                modelValue: _ctx.ruleForm.customerCompanyId,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.ruleForm.customerCompanyId) = $event)),
                placeholder: "输入关键字搜索",
                clearable: "",
                remote: "",
                onChange: _ctx.handleCompanyChange,
                onFocus: _cache[5] || (_cache[5] = ($event: any) => (_ctx.companyRemoteMethod(''))),
                "remote-method": query => _ctx.companyRemoteMethod(query)
              }, {
                default: _withCtx(() => [
                  (_ctx.companyOption.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.companyOption, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.name,
                          value: item.id,
                          disabled: item.disable
                        }, null, 8, ["label", "value", "disabled"]))
                      }), 128))
                    : (_openBlock(), _createBlock(_component_el_option, {
                        key: 1,
                        value: -1,
                        disabled: ""
                      }, {
                        default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                          _createTextVNode("暂无数据", -1)
                        ]))]),
                        _: 1
                      }))
                ]),
                _: 1
              }, 8, ["modelValue", "onChange", "remote-method"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "客户开票抬头",
            prop: "customerCompanyTicketId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                class: "filter-item",
                filterable: true,
                modelValue: _ctx.ruleForm.customerCompanyTicketId,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.ruleForm.customerCompanyTicketId) = $event)),
                placeholder: "输入关键字搜索",
                clearable: ""
              }, {
                default: _withCtx(() => [
                  (_ctx.customerCompanyTicketOption.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.customerCompanyTicketOption, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.titleName,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    : (_openBlock(), _createBlock(_component_el_option, {
                        key: 1,
                        value: -1,
                        disabled: ""
                      }, {
                        default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                          _createTextVNode("暂无数据", -1)
                        ]))]),
                        _: 1
                      }))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "联系人",
            prop: "customerCompanyContactId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                class: "filter-item",
                filterable: true,
                modelValue: _ctx.ruleForm.customerCompanyContactId,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.ruleForm.customerCompanyContactId) = $event)),
                placeholder: "输入关键字搜索",
                clearable: "",
                remote: "",
                onChange: _ctx.handleContactChange,
                onFocus: _cache[8] || (_cache[8] = ($event: any) => (_ctx.groupRemoteMethod(''))),
                "remote-method": query => _ctx.groupRemoteMethod(query)
              }, {
                default: _withCtx(() => [
                  (_ctx.companyConyactOption.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.companyConyactOption, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.name,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    : (_openBlock(), _createBlock(_component_el_option, {
                        key: 1,
                        value: -1,
                        disabled: ""
                      }, {
                        default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                          _createTextVNode("暂无数据", -1)
                        ]))]),
                        _: 1
                      }))
                ]),
                _: 1
              }, 8, ["modelValue", "onChange", "remote-method"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "邮箱",
            prop: "receivingEmail"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.ruleForm.receivingEmail,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.ruleForm.receivingEmail) = $event)),
                type: "input",
                class: "filter-item"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "收件地址",
            prop: "receivingAddress"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.ruleForm.receivingAddress,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.ruleForm.receivingAddress) = $event)),
                type: "input",
                class: "filter-item"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "报价人",
            prop: "salesManId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                class: "filter-item",
                filterable: true,
                modelValue: _ctx.ruleForm.salesManId,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.ruleForm.salesManId) = $event)),
                placeholder: "输入关键字搜索",
                clearable: ""
              }, {
                default: _withCtx(() => [
                  (_ctx.salesManOption.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.salesManOption, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.mark,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    : (_openBlock(), _createBlock(_component_el_option, {
                        key: 1,
                        value: -1,
                        disabled: ""
                      }, {
                        default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                          _createTextVNode("暂无数据", -1)
                        ]))]),
                        _: 1
                      }))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "报价单模版名称",
            prop: "templateName"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                class: "filter-item",
                filterable: true,
                modelValue: _ctx.ruleForm.templateName,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.ruleForm.templateName) = $event)),
                placeholder: "输入关键字搜索",
                clearable: "",
                onChange: _ctx.handleTemplateNameChange
              }, {
                default: _withCtx(() => [
                  (_ctx.printTemplateOption.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.printTemplateOption, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.name,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    : (_openBlock(), _createBlock(_component_el_option, {
                        key: 1,
                        value: -1,
                        disabled: ""
                      }, {
                        default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                          _createTextVNode("暂无数据", -1)
                        ]))]),
                        _: 1
                      }))
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"])
            ]),
            _: 1
          }),
          (_ctx.ruleForm.templateName)
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: "报价单备注模版",
                prop: "quotationMarkTemplateId"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    class: "filter-item",
                    filterable: true,
                    modelValue: _ctx.ruleForm.quotationMarkTemplateId,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.ruleForm.quotationMarkTemplateId) = $event)),
                    placeholder: "输入关键字搜索",
                    clearable: "",
                    onChange: _ctx.handleQuotationMarkTemplateChange
                  }, {
                    default: _withCtx(() => [
                      (_ctx.quotationMarkTempOption.length)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.quotationMarkTempOption, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.id,
                              label: item.name,
                              value: item.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        : (_openBlock(), _createBlock(_component_el_option, {
                            key: 1,
                            value: -1,
                            disabled: ""
                          }, {
                            default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                              _createTextVNode("暂无数据", -1)
                            ]))]),
                            _: 1
                          }))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, {
            label: "备注",
            prop: "mark",
            class: "fullWidth"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.ruleForm.mark,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.ruleForm.mark) = $event)),
                type: "textarea",
                class: "filter-item quotation-template",
                clearable: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_button, {
              onClick: _ctx.handleAddBusinessComand,
              type: "primary"
            }, {
              default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                _createTextVNode(" 添加业务 ", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, { onClick: _ctx.removeBusiness }, {
              default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                _createTextVNode(" 移除业务 ", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createVNode(_component_el_table, {
            data: _ctx.ruleForm.details,
            border: "",
            fit: "",
            "row-key": "id",
            class: "fullWidth",
            "summary-method": _ctx.getSummaries,
            "show-summary": "",
            "header-cell-style": { background: '#ddd', color: 'rgba(0,0,0,0.9)' },
            onSelectionChange: _ctx.handleTableSelect
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                type: "selection",
                width: "55"
              }),
              _createVNode(_component_el_table_column, {
                prop: "businessNo",
                label: "业务编号",
                width: "150"
              }),
              _createVNode(_component_el_table_column, {
                prop: "businessName",
                label: "业务名称"
              }),
              _createVNode(_component_el_table_column, {
                prop: "businessBrand",
                label: "业务品牌"
              }),
              _createVNode(_component_el_table_column, {
                prop: "businessModel",
                label: "型号"
              }),
              _createVNode(_component_el_table_column, {
                prop: "businessSerial",
                label: "序列号"
              }),
              _createVNode(_component_el_table_column, {
                prop: "businessAmount",
                label: "数量"
              }),
              (_ctx.ruleForm.taxRate)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_el_table_column, {
                      prop: "price",
                      label: "单价(含税)",
                      "min-width": "160"
                    }, {
                      default: _withCtx(({ row }) => [
                        _createVNode(_component_el_input_number, {
                          modelValue: row.price,
                          "onUpdate:modelValue": ($event: any) => ((row.price) = $event),
                          type: "number",
                          onInput: _cache[15] || (_cache[15] = ($event: any) => (_ctx.handleCalcTotal(1))),
                          precision: 2,
                          "controls-position": "right"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "priceWithRate",
                      label: "单价(未税)",
                      "min-width": "100",
                      align: "right"
                    }, {
                      default: _withCtx(({ row }) => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.priceWithoutRate(row.price, row.businessAmount, true)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "totalPrice",
                      label: "总价(含税)",
                      "min-width": "100",
                      align: "right"
                    }, {
                      default: _withCtx(({ row }) => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.numberTimes(row.price, row.businessAmount, true)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "totalPriceWithRate",
                      label: "总价(未税)",
                      "min-width": "100",
                      align: "right"
                    }, {
                      default: _withCtx(({ row }) => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.totalPriceWithoutRate(row.price, row.businessAmount, true)), 1)
                      ]),
                      _: 1
                    })
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_el_table_column, {
                      prop: "price",
                      label: "单价",
                      "min-width": "160"
                    }, {
                      default: _withCtx(({ row }) => [
                        _createVNode(_component_el_input_number, {
                          modelValue: row.price,
                          "onUpdate:modelValue": ($event: any) => ((row.price) = $event),
                          type: "number",
                          precision: 2,
                          "controls-position": "right"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "totalPrice",
                      label: "总价(RNB)",
                      "min-width": "100",
                      align: "right"
                    }, {
                      default: _withCtx(({ row }) => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.numberTimes(row.price, row.businessAmount, true)), 1)
                      ]),
                      _: 1
                    })
                  ], 64))
            ]),
            _: 1
          }, 8, ["data", "summary-method", "onSelectionChange"]),
          ([3, 4].includes(_ctx.ruleForm.templateName))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _cache[35] || (_cache[35] = _createElementVNode("h4", { class: "form-title fullWidth" }, [
                  _createElementVNode("span", { class: "left" }, "工作描述")
                ], -1)),
                _createVNode(_component_el_form_item, {
                  label: "故障现象",
                  prop: "fault",
                  class: "fullWidth"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.ruleForm.fault,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.ruleForm.fault) = $event)),
                      type: "textarea"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "检测情况",
                  prop: "checkDes",
                  class: "fullWidth"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.ruleForm.checkDes,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.ruleForm.checkDes) = $event)),
                      type: "textarea"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "更换配件",
                  prop: "changeParts",
                  class: "fullWidth"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.ruleForm.changeParts,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.ruleForm.changeParts) = $event)),
                      type: "textarea"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ], 64))
            : _createCommentVNode("", true),
          ([4].includes(_ctx.ruleForm.templateName))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _cache[38] || (_cache[38] = _createElementVNode("h4", { class: "form-title fullWidth" }, [
                  _createElementVNode("span", { class: "left" }, "配件费")
                ], -1)),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_el_button, {
                    onClick: _ctx.handlePartsAdd,
                    type: "primary"
                  }, {
                    default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                      _createTextVNode("添加", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_el_button, { onClick: _ctx.handlePartsDelete }, {
                    default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                      _createTextVNode("删除", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_el_table, {
                    data: _ctx.ruleForm.parts,
                    border: "",
                    fit: "",
                    class: "mt-20",
                    "header-cell-style": { background: '#ddd', color: 'rgba(0,0,0,0.9)' },
                    onSelectionChange: _ctx.handlePartsSelect,
                    "summary-method": _ctx.getSummaries,
                    "show-summary": ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        type: "selection",
                        width: "55"
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "name",
                        label: "名称",
                        width: "180"
                      }, {
                        default: _withCtx(({ row }) => [
                          _createVNode(_component_el_autocomplete, {
                            modelValue: row.name,
                            "onUpdate:modelValue": ($event: any) => ((row.name) = $event),
                            type: "text",
                            "fetch-suggestions": (query, cb) => _ctx.remoteFetchSuggestions(query, cb),
                            onChange: (value) => _ctx.handlePartsNameChange(value, row),
                            onSelect: (value) => _ctx.handlePartsNameChange(value, row)
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "fetch-suggestions", "onChange", "onSelect"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "amount",
                        label: "数量",
                        width: "100"
                      }, {
                        default: _withCtx(({ row }) => [
                          _createVNode(_component_el_input, {
                            modelValue: row.amount,
                            "onUpdate:modelValue": ($event: any) => ((row.amount) = $event),
                            type: "number",
                            min: 0,
                            onInput: _cache[19] || (_cache[19] = ($event: any) => (_ctx.handleCalcTotal(2)))
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      (_ctx.ruleForm.taxRate)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createVNode(_component_el_table_column, {
                              prop: "unitPrice",
                              label: "单价(含税)",
                              "min-width": "160"
                            }, {
                              default: _withCtx(({ row }) => [
                                _createVNode(_component_el_input_number, {
                                  modelValue: row.unitPrice,
                                  "onUpdate:modelValue": ($event: any) => ((row.unitPrice) = $event),
                                  type: "number",
                                  onInput: _cache[20] || (_cache[20] = ($event: any) => (_ctx.handleCalcTotal(2))),
                                  precision: 2,
                                  "controls-position": "right"
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "priceWithRate",
                              label: "单价(未税)",
                              "min-width": "100",
                              align: "right"
                            }, {
                              default: _withCtx(({ row }) => [
                                _createElementVNode("span", null, _toDisplayString(_ctx.priceWithoutRate(row.unitPrice, row.amount, true)), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "totalPrice",
                              label: "总价(含税)",
                              "min-width": "100",
                              align: "right"
                            }, {
                              default: _withCtx(({ row }) => [
                                _createElementVNode("span", null, _toDisplayString(_ctx.numberTimes(row.unitPrice, row.amount, true)), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "totalPriceWithRate",
                              label: "总价(未税)",
                              "min-width": "100",
                              align: "right"
                            }, {
                              default: _withCtx(({ row }) => [
                                _createElementVNode("span", null, _toDisplayString(_ctx.totalPriceWithoutRate(row.unitPrice, row.amount, true)), 1)
                              ]),
                              _: 1
                            })
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createVNode(_component_el_table_column, {
                              prop: "unitPrice",
                              label: "单价",
                              "min-width": "160"
                            }, {
                              default: _withCtx(({ row }) => [
                                _createVNode(_component_el_input_number, {
                                  modelValue: row.unitPrice,
                                  "onUpdate:modelValue": ($event: any) => ((row.unitPrice) = $event),
                                  type: "number",
                                  precision: 2,
                                  "controls-position": "right"
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "totalPrice",
                              label: "总价(RNB)",
                              "min-width": "100",
                              align: "right"
                            }, {
                              default: _withCtx(({ row }) => [
                                _createElementVNode("span", null, _toDisplayString(_ctx.numberTimes(row.unitPrice, row.amount, true)), 1)
                              ]),
                              _: 1
                            })
                          ], 64))
                    ]),
                    _: 1
                  }, 8, ["data", "onSelectionChange", "summary-method"])
                ]),
                _cache[39] || (_cache[39] = _createElementVNode("h4", { class: "form-title fullWidth" }, [
                  _createElementVNode("span", { class: "left" }, "维修费")
                ], -1)),
                _createVNode(_component_el_table, {
                  border: "",
                  fit: "",
                  class: "fullWidth mt-20",
                  "header-cell-style": { background: '#ddd', color: 'rgba(0,0,0,0.9)' },
                  data: _ctx.ruleForm.fee
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      prop: "amount",
                      label: "数量",
                      "min-width": "100"
                    }, {
                      default: _withCtx(({ row }) => [
                        _createVNode(_component_el_input, {
                          modelValue: row.amount,
                          "onUpdate:modelValue": ($event: any) => ((row.amount) = $event),
                          type: "number"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }),
                    (_ctx.ruleForm.taxRate)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_el_table_column, {
                            prop: "unitPrice",
                            label: "单价(含税)",
                            "min-width": "160"
                          }, {
                            default: _withCtx(({ row }) => [
                              _createVNode(_component_el_input_number, {
                                modelValue: row.unitPrice,
                                "onUpdate:modelValue": ($event: any) => ((row.unitPrice) = $event),
                                type: "number",
                                precision: 2,
                                "controls-position": "right"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "priceWithRate",
                            label: "单价(未税)",
                            "min-width": "100",
                            align: "right"
                          }, {
                            default: _withCtx(({ row }) => [
                              _createElementVNode("span", null, _toDisplayString(_ctx.priceWithoutRate(row.unitPrice, row.amount, true)), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "totalPrice",
                            label: "总价(含税)",
                            "min-width": "100",
                            align: "right"
                          }, {
                            default: _withCtx(({ row }) => [
                              _createElementVNode("span", null, _toDisplayString(_ctx.numberTimes(row.unitPrice, row.amount, true)), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "totalPriceWithRate",
                            label: "总价(未税)",
                            "min-width": "100",
                            align: "right"
                          }, {
                            default: _withCtx(({ row }) => [
                              _createElementVNode("span", null, _toDisplayString(_ctx.totalPriceWithoutRate(row.unitPrice, row.amount, true)), 1)
                            ]),
                            _: 1
                          })
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createVNode(_component_el_table_column, {
                            prop: "unitPrice",
                            label: "单价",
                            "min-width": "160"
                          }, {
                            default: _withCtx(({ row }) => [
                              _createVNode(_component_el_input_number, {
                                modelValue: row.unitPrice,
                                "onUpdate:modelValue": ($event: any) => ((row.unitPrice) = $event),
                                type: "number",
                                precision: 2,
                                "controls-position": "right"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            prop: "totalPrice",
                            label: "总价(RNB)",
                            "min-width": "100",
                            align: "right"
                          }, {
                            default: _withCtx(({ row }) => [
                              _createElementVNode("span", null, _toDisplayString(_ctx.numberTimes(row.unitPrice, row.amount, true)), 1)
                            ]),
                            _: 1
                          })
                        ], 64))
                  ]),
                  _: 1
                }, 8, ["data"])
              ], 64))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_button, { onClick: _ctx.cancle }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t("table.cancel")), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_el_button, {
        type: "primary",
        loading: _ctx.submitLoading,
        onClick: _ctx.handleSubmit
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t("table.confirm")), 1)
        ]),
        _: 1
      }, 8, ["loading", "onClick"]),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _ctx.handlePrint
      }, {
        default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
          _createTextVNode(" 打印 ", -1)
        ]))]),
        _: 1
      }, 8, ["onClick"])
    ]),
    (_ctx.dialogVisible)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 0,
          modelValue: _ctx.dialogVisible,
          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.dialogVisible) = $event)),
          title: "业务列表",
          width: "80%"
        }, {
          footer: _withCtx(() => [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_el_button, {
                onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.dialogVisible = false)),
                type: "danger"
              }, {
                default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                  _createTextVNode("取消", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.addBusiness
              }, {
                default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                  _createTextVNode("确定", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_BusinessTable, {
              mode: "table",
              ref: "BusinessList",
              customerCompanyId: _ctx.ruleForm.customerCompanyId,
              pageType: "QUOTE",
              excludeIds: _ctx.excludeIds
            }, null, 8, ["customerCompanyId", "excludeIds"])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.printVisible)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 1,
          modelValue: _ctx.printVisible,
          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.printVisible) = $event)),
          title: "打印预览",
          width: "80%"
        }, {
          footer: _withCtx(() => [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_el_button, {
                onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.printVisible = false)),
                type: "danger"
              }, {
                default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                  _createTextVNode("取消", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_PrintCom, {
              ref: "PrintCom",
              templateId: _ctx.ruleForm.templateName,
              detail: _ctx.ruleForm
            }, null, 8, ["templateId", "detail"])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ]))
}